<template>
  <form class="form-base">
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="v.name.$model"
          :errorMessages="getValidationErrorText(v.name)"
          :disabled="disabled"
          label="Наименование"
          outlined
					@blur="v.name.$touch"
        />
      </v-col>

      <v-col cols="12">
        <AddressStructuredField
          :value="v.address.$model"
          @change="v.address.$model = $event"
          :v="v.address"
          label="Адрес (место нахождения) организации"
          :notice-recovery="true"
          :global-disabled="disabled"
					@blur="v.address.$touch"
          :translationKey="translationKey ? `${translationKey}.addr` : undefined"
        />
      </v-col>
      <v-col cols="6">
        <v-text-field
          v-model="v.inn.$model"
          :errorMessages="getValidationErrorText(v.inn)"
          :disabled="disabled"
          label="ИНН организации"
          outlined
					@blur="v.inn.$touch"
        />
      </v-col>

      <v-col cols="12">
        <div class="form-base__title">
          ФИО лица, имеющего право без доверенности действовать от имени
          иностранного юридического лица
        </div>
      </v-col>
      <v-col cols="4">
        <v-text-field
          v-model.trim="v.assigneeLastName.$model"
          :errorMessages="getValidationErrorText(v.assigneeLastName)"
          :disabled="disabled"
          label="Фамилия"
          outlined
					@blur="v.assigneeLastName.$touch"
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          v-model.trim="v.assigneeName.$model"
          :errorMessages="getValidationErrorText(v.assigneeName)"
          :disabled="disabled"
          label="Имя"
          outlined
					@blur="v.assigneeName.$touch"
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          v-model.trim="v.assigneePatronymic.$model"
          :errorMessages="getValidationErrorText(v.assigneePatronymic)"
          :disabled="disabled"
          label="Отчество (при наличии)"
          outlined
					@blur="v.assigneePatronymic.$touch"
				/>
      </v-col>
    </v-row>
    <v-divider class="divider"></v-divider>
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="v.changeReason.$model"
          :errorMessages="getValidationErrorText(v.changeReason)"
          :disabled="disabled"
          label="Причина изменения кредитора"
          outlined
          @input="$emit('change-reason', $event)"
					@blur="v.changeReason.$touch"
        />
      </v-col>
    </v-row>
  </form>
</template>

<script>
import {
  getValidationErrorText,
  MAX_LENGTH,
  EMOJI,
  PERSON_NAME,
} from '@/utils/validate';
import { maxLength, required } from 'vuelidate/lib/validators';
import AddressStructuredField, {
  addressValidate,
} from '@/components/base/AddressStructuredField';

export const foreignOrganizationModel = {
  name: '',
  address: {},
  inn: '',
  assigneeLastName: '',
  assigneeName: '',
  assigneePatronymic: '',
  changeReason: '',
};

export const foreignOrganizationValidation = {
  name: {
    required,
    maxLength: maxLength(1000),
    EMOJI,
  },
  address: {
    required,
    ...addressValidate(),
  },
  inn: {
    required,
    maxLength: maxLength(10),
    EMOJI,
  },
  assigneeLastName: {
    required,
    maxLength: maxLength(MAX_LENGTH),
    PERSON_NAME,
  },
  assigneeName: {
    required,
    maxLength: maxLength(MAX_LENGTH),
    PERSON_NAME,
  },
  assigneePatronymic: {
    maxLength: maxLength(MAX_LENGTH),
    PERSON_NAME,
  },
  changeReason: {
    maxLength: maxLength(4000),
    EMOJI,
  },
};

export default {
  name: 'ForeignOrganization',
  components: { AddressStructuredField },
  props: {
    v: Object,
    disabled: Boolean,
    translationKey: String,
  },
  data: () => ({
    getValidationErrorText,
  }),
};
</script>

<style scoped></style>
